import React, { useEffect, useState } from "react";
import {
  Col,
  Divider,
  Row,
  Segmented,
  Spin,
  Tooltip,
  Typography,
} from "../../../components/common/utils/antd-imports/AntdImports";
import TermsRequestCard from "../../../components/common/terms-requests/TermsRequestCard";
import "./TermsRequestPage.css";
import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import { getSellerTermsRequests } from "../../../store/thunks/seller-thunks/SellerThunk";
import NoCampaignsCard from "../../../components/common/empty-view-card/EmptyViewCard";
import BreadcrumbNav from "../../../components/common/bread-crumbs/BreadCrumb";

const { Text } = Typography;

const TermsRequest = () => {
  const [segment, setSegment] = useState("pending_terms");
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const dispatch = useDispatch();

  const { requestsTerms, isTermsLoading, isTermsUpdationLoading } = useSelector(
    (state) => state.sellerterms
  );
  const isTermsGenericLoading = isTermsLoading || isTermsUpdationLoading;

  // Map each segment to corresponding payload
  const segmentPayloadMap = {
    pending_terms: 0,
    accepted_terms: 1,
    declined_terms: 2,
  };
  const header = "Request";
  const text =
    "You’re all caught up! Buyers haven’t sent any offer, terms, or cancellation requests yet.";

  const handleSegmentChange = (value) => {
    setSegment(value);
    const payload = segmentPayloadMap[value];
    dispatch(getSellerTermsRequests(payload));
  };

  let content;
  if (segment === "pending_terms") {
    content = <TermsRequestCard type="pending" segment={segment} />;
  } else if (segment === "accepted_terms") {
    content = <TermsRequestCard type="accepted" segment={segment} />;
  } else if (segment === "declined_terms") {
    content = <TermsRequestCard type="declined" segment={segment} />;
  }

  useEffect(() => {
    dispatch(getSellerTermsRequests(0));
  }, []);

  return (
    <div className="terms-requestpage">
      <div className="bread-crumb-placement">
        <BreadcrumbNav />
      </div>
      <Row className="review-buyer-text-cont">
        <Text className="review-buyer-text main-title-size">
          Review Buyer Requests
        </Text>
      </Row>

      {!isMobile && <Divider />}

      <Row justify="start">
        <Col xxl={8} xl={7} lg={5} />
        <Col xxl={7} xl={9} lg={10} className="terms-segment">
          <Segmented
            className="request-segments"
            value={segment}
            onChange={handleSegmentChange}
            size="small"
            options={[
              {
                value: "pending_terms",
                label: (
                  <div>
                    <Tooltip>
                      <Row justify="space-evenly" align="middle">
                        <span>Pending</span>
                      </Row>
                    </Tooltip>
                  </div>
                ),
              },
              {
                value: "accepted_terms",
                label: (
                  <div>
                    <Tooltip>
                      <Row justify="space-between" align="middle">
                        <span>Accepted</span>
                      </Row>
                    </Tooltip>
                  </div>
                ),
              },
              {
                value: "declined_terms",
                label: (
                  <div>
                    <Tooltip>
                      <Row justify="space-between" align="middle">
                        <span>Declined</span>
                      </Row>
                    </Tooltip>
                  </div>
                ),
              },
            ]}
          />
        </Col>
        <Col />
      </Row>

      <Row justify="center">
        {requestsTerms?.Terms_list?.data?.length <= 0 ? (
          <>
            <NoCampaignsCard header={header} text={text} />
          </>
        ) : (
          <>
            <div className="terms-card-container">{content}</div>
          </>
        )}

        {isTermsGenericLoading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spin size="large" fullscreen />
          </div>
        )}
      </Row>
    </div>
  );
};

export default TermsRequest;
